import * as React from 'react'
import { connect } from 'react-redux'
import { Text } from 'DVWebNodeUI'
import { RecordRefTag } from '../recordReftag/recordReftag'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { TrailerButton } from '../playButton/PlayButton'
import { Dispatch } from 'redux'
import { DetailPageActions } from '../../actions'
import { PlaybackContentLink } from '../../integrations/playerIntegration'
import { startPlayback } from '../../actions/player'

export const TRAILER_REFTAG = 'atv_dp_watch_trailer'

export interface ITrailerProps {
  playbackData?: WpsRuntime.atv.wps.TrailerFragmentModelProps
  sessionId: string
  pageTitleId: string
  usePlayer: boolean
}

type Props = ITrailerProps & ReturnType<typeof mapDispatchToProps>

export const ConnectedTrailer = ({ playbackData, sessionId, pageTitleId, usePlayer, startPlayback }: Props) => {
  if (!playbackData) {
    return null
  }

  const deeplinkingData = {
    ref: TRAILER_REFTAG,
    sessionId,
    fallbackUrl: playbackData.fallbackURL,
    titleId: playbackData.playbackID,
    isTrailer: true,
    useFullView: true,
    videoType: playbackData.videoMaterialType,
    pageTitleId: pageTitleId,
  }

  const handler = (e: React.MouseEvent) => {
    const contentConfig = {
      asin: playbackData.playbackID,
      trailer: true,
      position: 0,
      ref: TRAILER_REFTAG,
      videoType: playbackData.videoMaterialType,
      useFullView: true,
    }

    startPlayback({ contentConfig, playbackUrl: playbackData.playbackURL })
    e.preventDefault()
  }

  return (
    <RecordRefTag refTag={TRAILER_REFTAG} className="avu-full-width-phablet dv-dp-node-trailer">
      <TrailerButton
        onClick={usePlayer ? handler : undefined}
        forceDoubleHeight={true}
        deepLinkingData={deeplinkingData}
        href={playbackData.playbackURL}
      >
        <Text tag="span" string={playbackData.text} />
      </TrailerButton>
    </RecordRefTag>
  )
}

const mapDispatchToProps = (dispatch: Dispatch<DetailPageActions>) => ({
  startPlayback: (playbackContentLink: PlaybackContentLink) =>
    dispatch(startPlayback(playbackContentLink)),
})

export const Trailer = connect(null, mapDispatchToProps)(ConnectedTrailer)